<template>
  <div class="modal-card" style="width: auto; max-width: 480px;">
    <header class="modal-card-head">
      <div class="modal-card-title">Ajustes</div>
    </header>
    <section class="modal-card-body">
      <div class="columns is-multiline">
        <div class="column is-6">
          <label>Resultados solo de Amazon</label>
        </div>
        <div class="column is-6">
          <b-field>
            <div class="field">
              <b-switch v-model="settings.amazonOnly">
                {{ settings.amazonOnly ? "Sí" : "No" }}
              </b-switch>
            </div>
          </b-field>
        </div>
        <div class="column is-6">
          <label>Búsqueda inicial</label>
        </div>
        <div class="column is-6">
          <b-input v-model="settings.initialSearchQuery"></b-input>
        </div>
        <div class="column is-6">
          <label>Tipo de panel</label>
        </div>
        <div class="column is-6">
          <b-field>
            <b-radio-button
              v-model="settings.panelType"
              native-value="card"
              type="is-primary"
            >
              <b-icon pack="fas" icon="th"></b-icon>
              <span>Grid</span>
            </b-radio-button>
            <b-radio-button
              v-model="settings.panelType"
              native-value="media"
              type="is-primary"
            >
              <b-icon pack="fas" icon="th-list"></b-icon>
              <span>Lista</span>
            </b-radio-button>
          </b-field>
        </div>
        <!-- <div class="column is-6">
          <label>Icono de favoritos</label>
        </div>
        <div class="column is-6">
          <b-field>
            <b-radio-button
              v-model="settings.bookmarkIcon"
              native-value="fa-heart"
              type="is-primary"
            >
              <b-icon pack="fas" icon="heart"></b-icon>
              <span>Corazón</span>
            </b-radio-button>
            <b-radio-button
              v-model="settings.bookmarkIcon"
              native-value="fa-star"
              type="is-primary"
            >
              <b-icon pack="fas" icon="star"></b-icon>
              <span>Estrella</span>
            </b-radio-button>
          </b-field>
        </div> -->
        <div class="column is-6">
          <label>Resultados por página</label>
        </div>
        <div class="column is-6">
          <b-field>
            <b-radio-button
              v-model="settings.perPage"
              native-value="12"
              type="is-primary"
            >
              <span>12</span>
            </b-radio-button>
            <b-radio-button
              v-model="settings.perPage"
              native-value="24"
              type="is-primary"
            >
              <span>24</span>
            </b-radio-button>
          </b-field>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Cerrar
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: "TheSettings",
  props: {
    settings: {
      type: Object,
      required: true
    }
  },
  watch: {
    "settings.panelType"(settingValue) {
      this.onClickUpdateSettings("panelType", settingValue);
    },
    "settings.bookmarkIcon"(settingValue) {
      this.onClickUpdateSettings("bookmarkIcon", settingValue);
    },
    "settings.youtubeLink"(settingValue) {
      this.onClickUpdateSettings("youtubeLink", settingValue);
    },
    "settings.perPage"(settingValue) {
      this.onClickUpdateSettings("perPage", settingValue);
    },
    "settings.initialSearchQuery"(settingValue) {
      this.onClickUpdateSettings("initialSearchQuery", settingValue);
    },
    "settings.amazonOnly"(settingValue) {
      this.onClickUpdateSettings("amazonOnly", settingValue);
    }
  },
  methods: {
    onClickUpdateSettings(settingName, settingValue) {
      this.$emit("clickUpdateSettings", settingName, settingValue);
    }
  }
};
</script>

<style></style>
